module.exports = __webpack_public_path__ + "static/img/honor_1.86fbaf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/honor_1.jpg
// module id = 9Ivt
// module chunks = 0